import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import NotaFiscalItemForm from './NotaFiscalItemForm';
import TituloParcelaForm from './TituloParcelaForm';
import ModalPadraoForm from './ModalPadraoForm';
import SpinnerForm from './SpinnerForm';
import { getUsuario } from "../utils/LoginManager";
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;

export const OPCOES_COMBO_TIPO_DOC = [
  { key: '0', label: '0 - ENTRADA' },
  { key: '1', label: '1 - SAÍDA' },
]

export const OPCOES_COMBO_FORMA_PAGTO = [
  { key: '0', label: '0 - PAGTO À VISTA' },
  { key: '1', label: '1 - PAGTO À PRAZO' },
  { key: '2', label: '2 - OUTROS' },
]

export const OPCOES_COMBO_CONS_FINAL = [
  { key: '0', label: '0 - NÃO' },
  { key: '1', label: '1 - SIM' },
]

export const OPCOES_COMBO_FINALIDADE_EMISSAO = [
  { key: '1', label: '1 - NF-E NORMAL' },
  { key: '2', label: '2 - NF-E COMPL' },
  { key: '3', label: '3 - NF-E DE AJUSTE' },
  { key: '4', label: '4 - DEVOLUÇÃO' },
]

export const OPCOES_COMBO_TIPO_ATENDIMENTO = [
  { key: '0', label: '0 - NÃO SE APLICA' },
  { key: '1', label: '1 - OPERAÇÃO PRESENCIAL' },
  { key: '2', label: '2 - OPERAÇÃO NÃO PRESENCIAL, PELA INTERNET' },
  { key: '3', label: '3 - OPERAÇÃO NÃO PRESENCIAL, TELEATENDIMENTO' },
  { key: '4', label: '4 - NFC-E EM OPERAÇÃO COM ENTREGA A DOMICÍLIO' },
  { key: '9', label: '9 - OPERAÇÃO NÃO PRESENCIAL, OUTROS' },
]

export const OPCOES_COMBO_TIPO_FRETE = [
  { key: '0', label: '0 - POR CONTA DO EMITENTE' },
  { key: '1', label: '1 - POR CONTA DO DESTINATÁRIO / REMETENTE' },
  { key: '2', label: '2 - POR CONTA DE TERCEIROS' },
  { key: '9', label: '9 - SEM FRETE' },
]




export default class NotaFiscalEmissaoForm extends Component {

  state = {
    registro: {},
    modalProdutoVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "dados",

    OPCOES_COMBO_TIPO_MOV_NF: [],
    OPCOES_COMBO_EMITENTE: [],
    OPCOES_COMBO_CFOP: [],

    listaProdutos: [],
    listaNFRelacionadas: [],

    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

  };



  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      // console.log('componentDidUpdate', this.props.registroSelecionado)

      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        nf_destinatario: this.props.registroSelecionado.dados.nf_destinatario,
        nff_idf_transportadora: this.props.registroSelecionado.dados.nff_idf_transportadora,

        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        listaNFRelacionadas: this.props.registroSelecionado.listaNFRelacionadas ? this.props.registroSelecionado.listaNFRelacionadas : [],

        caixaFechado,
        visualizando: this.props.registroSelecionado.visualizar,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [])

        this.onBuscaTipoMovNF()
        this.onBuscaEmissor()
        this.onBuscaNatOper()
        this.forceUpdate()
      });

      if (this.props.registroSelecionado.dados.nf_idf) {
        this.setState({
          activeKey: "dados",
        });
      }
    }
  }





  onBuscaTipoMovNF = async () => {
    this.setState({ OPCOES_COMBO_TIPO_MOV_NF: [] })
    axios.get('/tipoMovNF/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_TIPO_MOV_NF = data.map(regList => {
          return {
            key: String(regList.tmnf_idf),
            label: regList.tmnf_descricao,
            tmnf_tipo_mov: regList.tmnf_tipo_mov,
            tmnf_gera_financ: regList.tmnf_gera_financ,
            tmnf_gera_estoque: regList.tmnf_gera_estoque,
          }
        });
        this.setState({
          registro: {
            ...this.state.registro,
            nf_tipo_mov_nf: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_tipo_mov_nf : OPCOES_COMBO_TIPO_MOV_NF.length ? OPCOES_COMBO_TIPO_MOV_NF[0] : { key: '', label: '', },
          },
          OPCOES_COMBO_TIPO_MOV_NF,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onChangeEmitente = event => {
    const { registro, OPCOES_COMBO_EMITENTE } = this.state;
    this.setState({ OPCOES_COMBO_MODELO: [] })
    const OPCOES_COMBO_MODELO = [];

    const value = event.target.value;
    const id = event.target.id;
    const iInd = OPCOES_COMBO_EMITENTE.findIndex(registro => String(registro.key) === String(value.key));

    if (OPCOES_COMBO_EMITENTE.length) {
      if (OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfce) {
        OPCOES_COMBO_MODELO.unshift({ key: '65', label: '65 - NFCE - NOTA FISCAL CONSUMIDOR ELETRÔNICA' });
      }
      if (OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfe) {
        OPCOES_COMBO_MODELO.unshift({ key: '55', label: '55 - NFE - NOTA FISCAL ELETRÔNICA' });
      }
    }

    registro[id] = value;
    this.setState({
      [id]: value,
      OPCOES_COMBO_MODELO,
      registro: {
        ...this.state.registro,
        nf_serie: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_serie : OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfe ? OPCOES_COMBO_EMITENTE[iInd].enf_nfe_serie : OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfce ? OPCOES_COMBO_EMITENTE[iInd].enf_nfce_serie : 0,
        nf_modelo: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_modelo : OPCOES_COMBO_MODELO.length ? OPCOES_COMBO_MODELO[0] : { key: '', label: '', },
      },
    });
  };

  onBuscaEmissor = async () => {
    this.setState({ OPCOES_COMBO_EMITENTE: [], OPCOES_COMBO_MODELO: [] })
    const OPCOES_COMBO_MODELO = [];
    axios.get('/emitenteNF/lista', {
      params: {
        tipo: 'PROD',
      }
    }).then(response => {
      const { data } = response;
      const OPCOES_COMBO_EMITENTE = data.map(regList => {
        return {
          key: String(regList.enf_idf),
          label: regList.enf_cnpj + ' - ' + regList.enf_razao_social + ' [' + (regList.enf_ambiente === 1 ? 'P' : 'H') + ']',
          enf_emissao_padrao: regList.enf_emissao_padrao,
          enf_cnpj: regList.enf_cnpj,
          enf_ambiente: regList.enf_ambiente,
          enf_flag_nfe: regList.enf_flag_nfe,
          enf_nfe_numero: regList.enf_nfe_numero,
          enf_nfe_serie: regList.enf_nfe_serie,
          enf_flag_nfce: regList.enf_flag_nfce,
          enf_nfce_numero: regList.enf_nfce_numero,
          enf_nfce_serie: regList.enf_nfce_serie,
          enf_token: regList.enf_token,
        }
      });
      if (OPCOES_COMBO_EMITENTE.length) {
        if (OPCOES_COMBO_EMITENTE[0].enf_flag_nfce) {
          OPCOES_COMBO_MODELO.unshift({ key: '65', label: '65 - NFCE - NOTA FISCAL CONSUMIDOR ELETRÔNICA' });
        }
        if (OPCOES_COMBO_EMITENTE[0].enf_flag_nfe) {
          OPCOES_COMBO_MODELO.unshift({ key: '55', label: '55 - NFE - NOTA FISCAL ELETRÔNICA' });
        }
      }
      this.setState({
        registro: {
          ...this.state.registro,
          nf_emitente: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_emitente : OPCOES_COMBO_EMITENTE.length ? OPCOES_COMBO_EMITENTE[0] : { key: '', label: '', },
          nf_modelo: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_modelo : OPCOES_COMBO_MODELO.length ? OPCOES_COMBO_MODELO[0] : { key: '', label: '', },
        },
        OPCOES_COMBO_EMITENTE,
        OPCOES_COMBO_MODELO,
      })
    }).catch(error => {
      console.error(error.response);
    })
  };


  onBuscaNatOper = async () => {
    this.setState({ OPCOES_COMBO_CFOP: [] })
    axios.get('/cfop/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_CFOP = data.map(regList => {
          return {
            key: String(regList.cfop_codigo),
            label: String(regList.cfop_codigo) + ' - ' + regList.cfop_descricao,
          }
        });
        this.setState({
          registro: {
            ...this.state.registro,
            nf_nat_oper: { key: '5102', label: '', },
          },
          OPCOES_COMBO_CFOP,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };






  onOK = (transmitir) => {
    const { registro, listaProdutos, listaParcelas, listaNFRelacionadas } = this.state;

    if ((!registro.nf_dt_emissao) || (!moment(registro.nf_dt_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Emissão Válida' });
      return;
    }
    if ((!registro.nf_dt_inclusao) || (!moment(registro.nf_dt_inclusao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Ent/Sai Válida' });
      return;
    }
    if ((!registro.nf_destinatario) || (registro.nf_destinatario.key === '0') || (registro.nf_destinatario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Destinatário', });
      return;
    }
    if ((!registro.nf_tipo_mov_nf) || (registro.nf_tipo_mov_nf.key === '0') || (registro.nf_tipo_mov_nf.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo da Nota Fiscal', });
      return;
    }
    if ((!registro.nf_emitente) || (registro.nf_emitente.key === '0') || (registro.nf_emitente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Emissor', });
      return;
    }
    if ((!registro.nf_modelo) || (registro.nf_modelo.key === '0') || (registro.nf_modelo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Modelo', });
      return;
    }
    if ((!registro.nf_tipo_documento) || (registro.nf_tipo_documento.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo Documento', });
      return;
    }
    if ((!registro.nf_nat_oper) || (registro.nf_nat_oper.key === '0') || (registro.nf_nat_oper.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Natureza da Operação', });
      return;
    }
    if ((!registro.nf_tipo_atendimento) || (registro.nf_tipo_atendimento.key === '0') || (registro.nf_tipo_atendimento.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Atendimento', });
      return;
    }
    if ((!registro.nf_consumidor_final) || (registro.nf_consumidor_final.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Consumidor Final', });
      return;
    }
    if ((!registro.nff_tipo) || (registro.nff_tipo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Frete', });
      return;
    }

    if ((!listaProdutos) || (listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na Nota' });
      return;
    }
    if ((listaParcelas) && (listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(registro.nf_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total da Nota não Confere com o Valor Total das parcelas' });
        return;
      }
    }

    const reg = {
      nf_tipo: 'NFe',
      nf_idf: registro.nf_idf,
      nf_numero: registro.nf_numero ? registro.nf_numero : 0,
      nf_serie: registro.nf_serie ? registro.nf_serie : 0,
      nf_dt_emissao: moment(registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      nf_dt_inclusao: moment(registro.nf_dt_inclusao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      nf_emitente: registro.nf_emitente.key,
      nf_destinatario: registro.nf_destinatario.key,
      nf_tipo_mov_nf: registro.nf_tipo_mov_nf.key,
      nf_modelo: registro.nf_modelo.key,
      nf_tipo_documento: registro.nf_tipo_documento.key,
      nf_nat_oper: registro.nf_nat_oper.key,
      nf_tipo_atendimento: registro.nf_tipo_atendimento.key,
      nf_forma_pagamento: registro.nf_forma_pagamento.key,
      nf_finalidade_emissao: registro.nf_finalidade_emissao.key,
      nf_consumidor_final: registro.nf_consumidor_final.key,

      nf_vlr_produtos: registro.nf_vlr_produtos,
      nf_bc_icms: registro.nf_bc_icms,
      nf_vlr_icms: registro.nf_vlr_icms,
      nf_bc_icms_st: registro.nf_bc_icms_st,
      nf_vlr_icms_st: registro.nf_vlr_icms_st,
      nf_vlr_ipi: registro.nf_vlr_ipi,
      nf_vlr_pis: registro.nf_vlr_pis,
      nf_vlr_cofins: registro.nf_vlr_cofins,
      nf_vlr_outras_desp: registro.nf_vlr_outras_desp,
      nf_vlr_frete: registro.nf_vlr_frete,
      nf_vlr_seguro: registro.nf_vlr_seguro,
      nf_vlr_desconto: registro.nf_vlr_desconto,
      nf_vlr_total: registro.nf_vlr_total,

      nf_obs_interna: registro.nf_obs_interna ? registro.nf_obs_interna : '',
      nfinf_texto: registro.nfinf_texto ? registro.nfinf_texto : '',

      nff_tipo: registro.nff_tipo.key,
      nff_idf_transportadora: registro.nff_idf_transportadora && registro.nff_idf_transportadora.key ? registro.nff_idf_transportadora.key : 0,
      nff_qtde_vol: registro.nff_qtde_vol,
      nff_especie: registro.nff_especie,
      nff_marca: registro.nff_marca,
      nff_num_volumes: registro.nff_num_volumes,
      nff_peso_liquido: registro.nff_peso_liquido,
      nff_peso_bruto: registro.nff_peso_bruto,

      nf_tipo_doc: registro.nf_tipo_doc.key,
      nf_cond_pagto: registro.nf_cond_pagto.key,

      listaProdutos,
      listaParcelas,
      listaNFRelacionadas,

      transmitir: transmitir,
    };


    this.props.onSalvarClick(reg);
  };

  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;

    // console.log('calculoTotalPedido', listaProdutos)

    let vlrProdutos = 0;
    let vlrBCICMS = 0;
    let vlrICMS = 0;
    let vlrBCICMSST = 0;
    let vlrICMSST = 0;
    let vlrIPI = 0;
    let vlrPIS = 0;
    let vlrCOFINS = 0;
    let vlrDespesa = 0;
    let vlrFrete = 0;
    let vlrSeguro = 0;
    let vlrDesconto = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      vlrProdutos = vlrProdutos +
        ((parseFloat(listaProdutos[x].nfi_qtde) * parseFloat(listaProdutos[x].nfi_vlr_unitario))
          - parseFloat(listaProdutos[x].nfi_vlr_desconto)
          + parseFloat(listaProdutos[x].nfi_vlr_despesas)
          + parseFloat(listaProdutos[x].nfi_vlr_frete)
          + parseFloat(listaProdutos[x].nfi_vlr_seguro)
        );

      vlrBCICMS = vlrBCICMS + parseFloat(listaProdutos[x].nficms_vbc);
      vlrICMS = vlrICMS + parseFloat(listaProdutos[x].nficms_vicms);
      vlrBCICMSST = vlrBCICMSST + parseFloat(listaProdutos[x].nficms_vbcst);
      vlrICMSST = vlrICMSST + parseFloat(listaProdutos[x].nficms_vicmsst);
      vlrIPI = vlrIPI + parseFloat(listaProdutos[x].nfipi_vipi);
      vlrPIS = vlrPIS + parseFloat(listaProdutos[x].nfpis_vpis);
      vlrCOFINS = vlrCOFINS + parseFloat(listaProdutos[x].nfcof_vcofinf);

      vlrDespesa = vlrDespesa + parseFloat(listaProdutos[x].nfi_vlr_despesas);
      vlrFrete = vlrFrete + parseFloat(listaProdutos[x].nfi_vlr_frete);
      vlrSeguro = vlrSeguro + parseFloat(listaProdutos[x].nfi_vlr_seguro);
      vlrDesconto = vlrDesconto + parseFloat(listaProdutos[x].nfi_vlr_desconto);

      vlrTotal = vlrTotal +
        ((parseFloat(listaProdutos[x].nfi_qtde) * parseFloat(listaProdutos[x].nfi_vlr_unitario))
          - parseFloat(listaProdutos[x].nfi_vlr_desconto)
          + parseFloat(listaProdutos[x].nfi_vlr_despesas)
          + parseFloat(listaProdutos[x].nfi_vlr_frete)
          + parseFloat(listaProdutos[x].nfi_vlr_seguro)
        )
        + parseFloat(listaProdutos[x].nficms_vicmsst)
        + parseFloat(listaProdutos[x].nfipi_vipi)
        ;

    };

    vlrProdutos = parseFloat(vlrProdutos.toFixed(2));
    vlrBCICMS = parseFloat(vlrBCICMS.toFixed(2));
    vlrICMS = parseFloat(vlrICMS.toFixed(2));
    vlrBCICMSST = parseFloat(vlrBCICMSST.toFixed(2));
    vlrICMSST = parseFloat(vlrICMSST.toFixed(2));
    vlrIPI = parseFloat(vlrIPI.toFixed(2));
    vlrPIS = parseFloat(vlrPIS.toFixed(2));
    vlrCOFINS = parseFloat(vlrCOFINS.toFixed(2));
    vlrDespesa = parseFloat(vlrDespesa.toFixed(2));
    vlrFrete = parseFloat(vlrFrete.toFixed(2));
    vlrSeguro = parseFloat(vlrSeguro.toFixed(2));
    vlrDesconto = parseFloat(vlrDesconto.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.nf_vlr_produtos = vlrProdutos;
    registro.nf_bc_icms = vlrBCICMS;
    registro.nf_vlr_icms = vlrICMS;
    registro.nf_bc_icms_st = vlrBCICMSST;
    registro.nf_vlr_icms_st = vlrICMSST;
    registro.nf_vlr_ipi = vlrIPI;
    registro.nf_vlr_pis = vlrPIS;
    registro.nf_vlr_cofins = vlrCOFINS;
    registro.nf_vlr_outras_desp = vlrDespesa;
    registro.nf_vlr_frete = vlrFrete;
    registro.nf_vlr_seguro = vlrSeguro;
    registro.nf_vlr_desconto = vlrDesconto;
    registro.nf_vlr_total = vlrTotal;

    this.setState({
      registro: {
        ...registro
      },
    });
  }








  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    if ((!this.state.nf_destinatario) || (this.state.nf_destinatario.key === '') || (this.state.nf_destinatario.key === '0')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Destinatário da Nota', });
      return;
    }

    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        registro: {
          nfi_seq: 0,
          nfi_produto: { key: '0' },
          nfi_prduto_codigo: '',
          nfi_descricao_produto: '',
          nfi_ncm: '',
          nfi_cfop: { key: '5102' },

          tipo_contribuinte: this.state.registro.nf_destinatario.pes_ind_ie,
          uf_destinatario: this.state.registro.nf_destinatario.cuf_codigo,
          tipo_mov_nf: this.state.registro.nf_tipo_mov_nf.key,

          nfi_qtde: 1,
          nfi_vlr_unitario: 0,
          nfi_vlr_despesas: 0,
          nfi_perc_desconto: 0,
          nfi_vlr_desconto: 0,
          nfi_vlr_frete: 0,
          nfi_vlr_seguro: 0,
          nfi_vlr_total: 0,

          nficms_origem: { key: '0' },
          nficms_modbc: { key: '0' },

          nficms_cst: { key: '' },
          nficms_vbc: 0,
          nficms_picms: 0,
          nficms_vicms: 0,

          nficms_vbcst: 0,
          nficms_picmsst: 0,
          nficms_vicmsst: 0,

          nfipi_cst: { key: '' },
          nfipi_vbc: 0,
          nfipi_pipi: 0,
          nfipi_vipi: 0,

          nfpis_cst: { key: '' },
          nfpis_vbc: 0,
          nfpis_ppis: 0,
          nfpis_vpis: 0,

          nfcof_cst: { key: '' },
          nfcof_vbc: 0,
          nfcof_pcofins: 0,
          nfcof_vcofinf: 0,

          nfci_cst: { key: '' },
          nfci_sit_trib_ibs_cbs: '',
          nfci_bc: 0,
          nfci_pibs_mun: 0,
          nfci_vibs_mun: 0,
          nfci_pibs_est: 0,
          nfci_vibs_est: 0,
          nfci_pcbs: 0,
          nfci_vcbs: 0,

        }
      }
    });
  }

  onEditarProdutosClick = (reg, visualizar) => {
    // console.log('onEditarProdutosClick', reg)

    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        visualizar,

        registro: {
          nfi_seq: reg.nfi_seq,

          nfi_produto: {
            key: String(reg.nfi_produto) + '_' + String(reg.nfi_item_tamanho) + '_' + String(reg.nfi_item_cor),
            label: (reg.prod_grade ? (reg.nfi_descricao_produto + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.nfi_descricao_produto) + ' [' + reg.nfi_prduto_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),

            idf: String(reg.nfi_produto),
            cod: String(reg.nfi_prduto_codigo),
            descr: String(reg.nfi_descricao_produto),
            med_descricao: reg.med_descricao,
            prod_ncm: reg.nfi_ncm,
            prod_tipo_produto: reg.nfi_produto.prod_tipo_produto,
            prod_cod_barras: reg.nfi_produto.prod_cod_barras,

            prod_grade: reg.prod_grade,
            nfi_item_tamanho: reg.nfi_item_tamanho,
            nfi_item_cor: reg.nfi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },

          nfi_prduto_codigo: reg.nfi_prduto_codigo,
          nfi_descricao_produto: reg.nfi_descricao_produto,
          nfi_unid_medida: reg.nfi_unid_medida,
          nfi_ncm: reg.nfi_ncm,
          nfi_cfop: { key: String(reg.nfi_cfop) },

          nfi_qtde: reg.nfi_qtde,
          nfi_vlr_unitario: reg.nfi_vlr_unitario,
          nfi_qtde: reg.nfi_qtde,
          nfi_perc_desconto: reg.nfi_perc_desconto,
          nfi_vlr_desconto: reg.nfi_vlr_desconto,
          nfi_vlr_despesas: reg.nfi_vlr_despesas,
          nfi_vlr_frete: reg.nfi_vlr_frete,
          nfi_vlr_seguro: reg.nfi_vlr_seguro,
          nfi_vlr_total: reg.nfi_vlr_total,

          nficms_origem: { key: String(reg.nficms_origem) },
          nficms_modbc: { key: String(reg.nficms_modbc) },

          nficms_cst: { key: String(reg.nficms_cst).padStart(3, '0') },
          nficms_vbc: reg.nficms_vbc,
          nficms_picms: reg.nficms_picms,
          nficms_vicms: reg.nficms_vicms,

          nficms_vbcst: reg.nficms_vbcst,
          nficms_picmsst: reg.nficms_picmsst,
          nficms_vicmsst: reg.nficms_vicmsst,

          nfipi_cst: { key: String(reg.nfipi_cst).padStart(2, '0') },
          nfipi_vbc: reg.nfipi_vbc,
          nfipi_pipi: reg.nfipi_pipi,
          nfipi_vipi: reg.nfipi_vipi,

          nfpis_cst: { key: String(reg.nfpis_cst).padStart(2, '0') },
          nfpis_vbc: reg.nfpis_vbc,
          nfpis_ppis: reg.nfpis_ppis,
          nfpis_vpis: reg.nfpis_vpis,

          nfcof_cst: { key: String(reg.nfcof_cst).padStart(2, '0') },
          nfcof_vbc: reg.nfcof_vbc,
          nfcof_pcofins: reg.nfcof_pcofins,
          nfcof_vcofinf: reg.nfcof_vcofinf,

          nfci_cst: { key: String(reg.nfci_cst).padStart(3, '0') },
          nfci_sit_trib_ibs_cbs: reg.nfci_sit_trib_ibs_cbs,
          nfci_bc: reg.nfci_bc,
          nfci_pibs_mun: reg.nfci_pibs_mun,
          nfci_vibs_mun: reg.nfci_vibs_mun,
          nfci_pibs_est: reg.nfci_pibs_est,
          nfci_vibs_est: reg.nfci_vibs_est,
          nfci_pcbs: reg.nfci_pcbs,
          nfci_vcbs: reg.nfci_vcbs,

        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Item?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.nfi_produto + '_' + registro.nfi_item_tamanho + '_' + registro.nfi_item_cor === reg.nfi_produto + '_' + reg.nfi_item_tamanho + '_' + reg.nfi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        {this.state.visualizando || this.state.caixaFechado ? (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarProdutosClick(registro, true)} icon="eye" />
          </Tooltip>
        ) : (
          <Tooltip title="Editar">
            <Button type="primary" onClick={() => this.onEditarProdutosClick(registro, false)} icon="edit" />
          </Tooltip>
        )}
        {this.state.visualizando || this.state.caixaFechado ? null : (
          <Tooltip title="Excluir">
            <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };

  // ----------------------------------------------------------------
  // FIM PRODUTOS
  // ----------------------------------------------------------------








  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.nf_tipo_doc) || (this.state.registro.nf_tipo_doc.key === '0') || (this.state.registro.nf_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.nf_cond_pagto) || (this.state.registro.nf_cond_pagto.key === '0') || (this.state.registro.nf_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.nf_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.nf_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.nf_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.nf_vlr_total) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.nf_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.nf_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.nf_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.nf_vlr_total)).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.nf_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.nf_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  // ----------------------------------------------------------------
  // FIM PARCELAS
  // ----------------------------------------------------------------








  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['nf_destinatario'] = event.nf_destinatario;
    this.setState(event);
  }

  onChangeTransportador = event => {
    const { registro } = this.state;
    registro['nff_idf_transportadora'] = event.nff_idf_transportadora;
    this.setState(event);
  }

  onDateEmissaoChange = event => {
    const { registro } = this.state;
    registro['nf_dt_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ nf_dt_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDateEntSaiChange = event => {
    const { registro } = this.state;
    registro['nf_dt_inclusao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ nf_dt_inclusao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  renderValor = (nf_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(nf_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderTipoItem = (tipo) => {
    return (
      <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
    );
  };

  renderDescrProduto = (descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? descricao : registro.descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['nf_tipo_doc'] = event.nf_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['nf_cond_pagto'] = event.nf_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  renderAcoesNFRel = (registro) => {
    return (
      <Tooltip title="Excluir">
        <Button type="ghost" onClick={() => this.onNaoAplicaClick(registro)} icon="delete" />
      </Tooltip>
    );
  };

  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'clientes'
    });
  }

  onCadTranspClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'transportadoras'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }












  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarNFProdClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, visualizando, listaProdutos, listaParcelas, listaNFRelacionadas, produtoSelecionado, OPCOES_COMBO_EMITENTE, OPCOES_COMBO_TIPO_MOV_NF, OPCOES_COMBO_CFOP, OPCOES_COMBO_MODELO,
      vlrDifParc, vlrTotalParc, caixaFechado, modalListaVisible, modalParcelaVisible, modalProdutoVisible, tipoPessoa } = this.state;

    const { nf_idf, nf_numero, nf_serie, nf_status, situacao_nota, nf_tipo, nf_tipo_mov_nf, nf_destinatario, nf_obs_interna, nf_dt_emissao, nf_dt_inclusao, nf_chave, nf_tipo_doc, nfinf_texto,
      nf_cond_pagto, nff_tipo, nff_idf_transportadora, nff_num_volumes, nff_especie, nff_marca, nff_qtde_vol, nff_peso_bruto, nff_peso_liquido, nf_chave_rel,
      nf_emitente, nf_modelo, nf_nat_oper, nf_forma_pagamento, nf_finalidade_emissao, nf_consumidor_final, nf_tipo_documento, nf_tipo_atendimento,
      nf_vlr_total, nf_vlr_cofins, nf_vlr_desconto, nf_vlr_frete, nf_vlr_icms, nf_vlr_icms_st, nf_vlr_ipi, nf_vlr_outras_desp, nf_vlr_pis, nf_vlr_produtos, nf_vlr_seguro, nf_bc_icms, nf_bc_icms_st
    } = this.state.registro;

    // console.log('NotaFiscalEmissaoForm.this.state: ', this.state);
    // console.log('NotaFiscalEmissaoForm.this.state: ', this.state.registro);

    return (
      <Modal
        title={nf_idf ? (visualizando ? "Nota Fiscal de Produto" : "Edição de Nota Fiscal de Produto") : "Inclusão de Nota Fiscal de Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarNFProdClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoPessoa}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <NotaFiscalItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={nf_vlr_total}
          condPagto={nf_cond_pagto}
        />

        <SpinnerForm visivel={carregando} texto={'Transmitindo Nota. Aguarde...'} />



        <Row>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Numero</span>
              <InputForm
                id="nf_numero"
                ref="nf_numero"
                maxLength={9}
                onChange={this.onChange}
                value={nf_numero}
                readOnly
              />
            </Col>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Série</span>
              <InputForm
                id="nf_serie"
                ref="nf_serie"
                maxLength={9}
                onChange={this.onChange}
                value={nf_serie}
                readOnly
              />
            </Col>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Situação</span>
              <InputForm
                id="situacao_nota"
                ref="situacao_nota"
                maxLength={20}
                onChange={this.onChange}
                value={situacao_nota}
                readOnly
              />
            </Col>
            <Col xs={24} sm={3} className="camposEspacoDireita">
              <span>Origem</span>
              <InputForm
                id="nf_tipo"
                ref="nf_tipo"
                maxLength={20}
                onChange={this.onChange}
                value={nf_tipo}
                readOnly
              />
            </Col>
            <Col xs={24} sm={9}>
              <span>Tipo Nota Fiscal *</span>
              <InputForm
                type="select"
                id="nf_tipo_mov_nf"
                ref="nf_tipo_mov_nf"
                value={nf_tipo_mov_nf}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_MOV_NF}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                disabled={caixaFechado || nf_tipo !== 'NFe'}
              />
            </Col>

            <Col xs={24} sm={11} style={{ marginTop: -20 }}>
              <PessoaFrame
                label="Remetente/Destinatário *"
                id="nf_destinatario"
                value={nf_destinatario}
                tipo="C"
                width={"100%"}
                onChange={this.onChangePessoa}
                disabled={caixaFechado || nf_tipo !== 'NFe'}
                descricaoPrimeiroItem="Selecione um Destinatário"
              />
            </Col>
            <Col xs={24} sm={1} style={{ marginTop: 4, paddingRight: 20 }}>
              <Tooltip title="Cadastro de Clientes" placement="topLeft">
                <Button
                  type="dashed"
                  icon="plus"
                  htmlType="button"
                  onClick={() => this.onCadPessoaClick()}
                  disabled={visualizando}
                />
              </Tooltip>
            </Col>
            <Col xs={24} sm={12} style={{ marginTop: -20 }} >
              <span>OBS Interna</span>
              <InputForm
                id="nf_obs_interna"
                ref="nf_obs_interna"
                maxLength={200}
                onChange={this.onChange}
                value={nf_obs_interna}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -14 }} className="camposEspacoDireita">
              <span>Data Emissão *</span>
              <DatePicker
                onChange={this.onDateEmissaoChange}
                format="DD/MM/YYYY"
                showToday={true}
                allowClear={false}
                value={moment(nf_dt_emissao, "DD/MM/YYYY", true)}
                style={{ width: "100%" }}
                disabled={caixaFechado || nf_tipo !== 'NFe'}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -14 }} className="camposEspacoDireita">
              <span>Data Ent/Sai *</span>
              <DatePicker
                onChange={this.onDateEntSaiChange}
                format="DD/MM/YYYY"
                showToday={true}
                allowClear={false}
                value={moment(nf_dt_inclusao, "DD/MM/YYYY", true)}
                style={{ width: "100%" }}
                disabled={caixaFechado || nf_tipo !== 'NFe'}
              />
            </Col>
            <Col xs={24} sm={12} style={{ marginTop: -20 }}  >
              <span>Chave</span>
              <InputForm
                id="nf_chave"
                ref="nf_chave"
                maxLength={9}
                onChange={this.onChange}
                value={nf_chave}
                readOnly
              />
            </Col>
          </Row>

          <div className="divider-lg-form" />

          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
            tabBarStyle={{ color: Colors.primary, fontWeight: 'bold' }}
          >

            <TabPane tab="Dados Fiscais" key="dados">
              <div style={{ height: 250 }}>
                <Form>
                  <Row>
                    <Col xs={24} sm={9} className="camposEspacoDireita">
                      <span>Emissor *</span>
                      <InputForm
                        type="select"
                        id="nf_emitente"
                        ref="nf_emitente"
                        value={nf_emitente}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChangeEmitente}
                        data={OPCOES_COMBO_EMITENTE}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                        showSearch
                      />
                    </Col>
                    <Col xs={24} sm={9} className="camposEspacoDireita">
                      <span>Modelo *</span>
                      <InputForm
                        type="select"
                        id="nf_modelo"
                        ref="nf_modelo"
                        value={nf_modelo}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_MODELO}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                        showSearch
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{}} className="camposEspacoDireita">
                      <span>Tipo Documento *</span>
                      <InputForm
                        type="select"
                        id="nf_tipo_documento"
                        ref="nf_tipo_documento"
                        value={nf_tipo_documento}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_TIPO_DOC}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={16} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Natureza da Operação *</span>
                      <InputForm
                        type="select"
                        id="nf_nat_oper"
                        ref="nf_nat_oper"
                        value={nf_nat_oper}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_CFOP}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                        showSearch
                      />
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: -20 }} >
                      <span>Tipo Atendimento *</span>
                      <InputForm
                        type="select"
                        id="nf_tipo_atendimento"
                        ref="nf_tipo_atendimento"
                        value={nf_tipo_atendimento}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_TIPO_ATENDIMENTO}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Forma Pagto *</span>
                      <InputForm
                        type="select"
                        id="nf_forma_pagamento"
                        ref="nf_forma_pagamento"
                        value={nf_forma_pagamento}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_FORMA_PAGTO}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Finalidade Emissão *</span>
                      <InputForm
                        type="select"
                        id="nf_finalidade_emissao"
                        ref="nf_finalidade_emissao"
                        value={nf_finalidade_emissao}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_FINALIDADE_EMISSAO}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                      <span>Consum. Final *</span>
                      <InputForm
                        type="select"
                        id="nf_consumidor_final"
                        ref="nf_consumidor_final"
                        value={nf_consumidor_final}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_CONS_FINAL}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Produtos da Nota" key="produtos">
              <div style={{ height: 250 }}>
                {visualizando ? null : (
                  <Row>
                    <Col xs={24} style={{ marginTop: -60 }}>
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={this.onNovoProduto}
                        icon="plus"
                        className="btn-primary"
                      > Novo Produto
                      </Button>
                    </Col>
                  </Row>
                )}
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  scroll={{ x: 950, y: 320 }}
                  rowKey={(listaProdutos => listaProdutos.nfi_produto + '_' + listaProdutos.nfi_item_tamanho + '_' + listaProdutos.nfi_item_cor)}
                >
                  <Column
                    key="nfi_prduto_codigo"
                    dataIndex="nfi_prduto_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfi_descricao_produto"
                    dataIndex="nfi_descricao_produto"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="nfi_ncm"
                    dataIndex="nfi_ncm"
                    title="NCM"
                    width={95}
                    align="center"
                    className="listaCadastro"
                    render={valor => valor == null ? '' : String(valor)}
                  />
                  <Column
                    key="nfi_cfop"
                    dataIndex="nfi_cfop"
                    title="CFOP"
                    width={70}
                    align="center"
                    className="listaCadastro"
                    render={valor => valor == null ? '' : String(typeof valor === 'object' ? (valor.key || '') : valor)}
                  />
                  <Column
                    key="nfi_qtde"
                    dataIndex="nfi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfi_vlr_unitario"
                    dataIndex="nfi_vlr_unitario"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfi_vlr_desconto"
                    dataIndex="nfi_vlr_desconto"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfi_vlr_total"
                    dataIndex="nfi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={70}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            </TabPane>


            <TabPane tab="Inf. Adicionais" key="infCompl">
              <div style={{ height: 250 }}>
                <Row>
                  <Col xs={24} style={{}}>
                    <span>Informações complementares de interesso do contribuinte</span>
                    <InputForm
                      id="nfinf_texto"
                      ref="nfinf_texto"
                      value={nfinf_texto}
                      type="textarea"
                      rows={9}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>


            <TabPane tab="Transporte" key="transporte">
              <div style={{ height: 250 }}>
                <Row>
                  <Col xs={24} sm={12} className="camposEspacoDireita">
                    <span>Frete por conta de</span>
                    <InputForm
                      type="select"
                      id="nff_tipo"
                      ref="nff_tipo"
                      value={nff_tipo}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_TIPO_FRETE}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={11} style={{}}>
                    <PessoaFrame
                      label="Transportador"
                      id="nff_idf_transportadora"
                      value={nff_idf_transportadora}
                      tipo="T"
                      width={"100%"}
                      onChange={this.onChangeTransportador}
                      descricaoPrimeiroItem="Selecione um Transportador"
                    />
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: 25 }}>
                    <Tooltip title="Cadastro de Transportadora" placement="topLeft">
                      <Button
                        type="dashed"
                        icon="plus"
                        htmlType="button"
                        onClick={() => this.onCadTranspClick()}
                        disabled={visualizando}
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Qtde Volumes</span>
                    <InputForm
                      type="number"
                      id="nff_qtde_vol"
                      ref="nff_qtde_vol"
                      value={nff_qtde_vol}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Peso Bruto</span>
                    <InputForm
                      type="number"
                      id="nff_peso_bruto"
                      ref="nff_peso_bruto"
                      value={nff_peso_bruto}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Peso Liquido</span>
                    <InputForm
                      type="number"
                      id="nff_peso_liquido"
                      ref="nff_peso_liquido"
                      value={nff_peso_liquido}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }} >
                    <span>Numeração</span>
                    <InputForm
                      id="nff_num_volumes"
                      ref="nff_num_volumes"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_num_volumes}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }} >
                    <span>Espécie</span>
                    <InputForm
                      id="nff_especie"
                      ref="nff_especie"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_especie}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} >
                    <span>Marca</span>
                    <InputForm
                      id="nff_marca"
                      ref="nff_marca"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_marca}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>



            <TabPane tab="NFs Relacionadas" key="nfrelacionadas">
              <div style={{ height: 250 }}>
                <Row>
                  <Col xs={24} sm={20} style={{ marginTop: 0 }}  >
                    <span>Chave</span>
                    <InputForm
                      id="nf_chave_rel"
                      ref="nf_chave_rel"
                      maxLength={44}
                      onChange={this.onChange}
                      value={nf_chave_rel}
                    />
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: 20 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                      disabled={visualizando}
                    > Adicionar
                    </Button>
                  </Col>
                </Row>

                <div>
                  <Table
                    loading={{
                      spinning: carregandoForm,
                      tip: 'Carregando. Aguarde...',
                      size: "large"
                    }}
                    dataSource={listaNFRelacionadas}
                    pagination={false}
                    scroll={{ y: 130 }}
                    rowKey={(listaNFRelacionadas => listaNFRelacionadas.nfr_chave)}
                  >
                    <Column
                      key="nfr_chave"
                      dataIndex="nfr_chave"
                      title="Chave Nota Relacionada"
                      width={"75%"}
                      align="left"
                      className="listaCadastro"
                    />
                    <Column
                      key="acoes"
                      title=""
                      render={this.state.registro.nf_idf ? '' : this.renderAcoesNFRel}
                      width={"25%"}
                      align="center"
                      className="listaCadastro"
                    />
                  </Table>
                </div>
              </div>
            </TabPane>




            <TabPane tab="Cobrança" key="formaPagto">
              <div style={{ height: 250 }}>

                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: 0 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="nf_tipo_doc"
                          value={nf_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: 0 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="nf_cond_pagto"
                          value={nf_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(nf_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      scroll={{ y: 320 }}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>

          <div className="divider-lg-form" />

          <Row>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor Produtos</span>
              <InputForm
                type="number"
                id="nf_vlr_produtos"
                ref="nf_vlr_produtos"
                value={nf_vlr_produtos}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>BC ICMS</span>
              <InputForm
                type="number"
                id="nf_bc_icms"
                ref="nf_bc_icms"
                value={nf_bc_icms}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor ICMS</span>
              <InputForm
                type="number"
                id="nf_vlr_icms"
                ref="nf_vlr_icms"
                value={nf_vlr_icms}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>BC ICMS Subst</span>
              <InputForm
                type="number"
                id="nf_bc_icms_st"
                ref="nf_bc_icms_st"
                value={nf_bc_icms_st}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Vlr ICMS Subst</span>
              <InputForm
                type="number"
                id="nf_vlr_icms_st"
                ref="nf_vlr_icms_st"
                value={nf_vlr_icms_st}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor IPI</span>
              <InputForm
                type="number"
                id="nf_vlr_ipi"
                ref="nf_vlr_ipi"
                value={nf_vlr_ipi}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor PIS</span>
              <InputForm
                type="number"
                id="nf_vlr_pis"
                ref="nf_vlr_pis"
                value={nf_vlr_pis}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor COFINS</span>
              <InputForm
                type="number"
                id="nf_vlr_cofins"
                ref="nf_vlr_cofins"
                value={nf_vlr_cofins}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Outras Desp</span>
              <InputForm
                type="number"
                id="nf_vlr_outras_desp"
                ref="nf_vlr_outras_desp"
                value={nf_vlr_outras_desp}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Frete</span>
              <InputForm
                type="number"
                id="nf_vlr_frete"
                ref="nf_vlr_frete"
                value={nf_vlr_frete}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Seguro</span>
              <InputForm
                type="number"
                id="nf_vlr_seguro"
                ref="nf_vlr_seguro"
                value={nf_vlr_seguro}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Desconto</span>
              <InputForm
                type="number"
                id="nf_vlr_desconto"
                ref="nf_vlr_desconto"
                value={nf_vlr_desconto}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Total Nota</span>
              <InputForm
                type="number"
                id="nf_vlr_total"
                ref="nf_vlr_total"
                value={nf_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>

        </Row>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando || caixaFechado ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={() => (
                      Modal.confirm({
                        title: 'Confirmação de Emissão',
                        content: `Deseja TRANSMITIR a Nota?`,
                        okText: 'Sim',
                        cancelText: 'Não',
                        onOk: () => this.onOK(1),
                        onCancel: () => this.onOK(0),
                      })
                    )}
                    className="btn-salvar"
                  >
                    Salvar Nota
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarNFProdClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotaFiscalEmissaoForm.js